import { RpcService } from 'rpc';
import { ToolState, ServerConfig, MPEItems } from '../interfaces';
import { ParentTree, PostTestResults } from 'lcc-interfaces';

export interface IStateSvc extends RpcService {
	get_config(): Promise<ServerConfig>;
	//
	set_state(params: { key: 'assessment'; state: ParentTree }): Promise<any>;
	set_state(params: { key: 'examdate'; state: string }): Promise<any>;
	set_state(params: { key: 'location'; state: string }): Promise<any>;
	set_state(params: { key: 'posttest'; state: PostTestResults }): Promise<any>;
	set_state(params: { key: 'practice'; state: ParentTree }): Promise<any>;
	set_state(params: { key: 'quizpattern'; state: string }): Promise<any>;
	set_state(params: { key: 'status'; state: ParentTree }): Promise<any>;
	set_state(params: { key: 'toolstate'; state: ToolState }): Promise<any>;
	set_state(params: { key: 'mpe'; state: MPEItems }): Promise<any>;
	set_state(params: {
		key: string;
		state: string | ParentTree | ToolState | PostTestResults | MPEItems;
	}): Promise<any>;
	//
	get_state(params: { key: 'assessment' }): Promise<ParentTree>;
	get_state(params: { key: 'examdate' }): Promise<string>;
	get_state(params: { key: 'location' }): Promise<string>;
	get_state(params: { key: 'posttest' }): Promise<PostTestResults>;
	get_state(params: { key: 'practice' }): Promise<ParentTree>;
	get_state(params: { key: 'quizpattern' }): Promise<string>;
	get_state(params: { key: 'status' }): Promise<ParentTree>;
	get_state(params: { key: 'toolstate' }): Promise<ToolState>;
	get_state(params: { key: 'mpe' }): Promise<MPEItems>;
	get_state(params: { key: string }): Promise<string | ParentTree | PostTestResults | ToolState | MPEItems>;
}

export const svc: IStateSvc = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,

	services: {
		get_config: {
			parameters: []
		},
		set_state: {
			parameters: [
				{
					name: 'key',
					type: 'string',
					optional: false
				},
				{
					name: 'state',
					type: ['string', 'object'],
					optional: false
				}
			]
		},
		get_state: {
			parameters: [
				{
					name: 'key',
					type: 'string',
					optional: false
				}
			]
		}
	}
}) as IStateSvc;

export default svc;
